import { InvoiceArticleCategory } from 'src/modules/invoice/models/invoiceArticleCategory';
import { InvoiceArticleCategorySearchFilter } from 'src/modules/invoice/models/invoiceArticleCategorySearchFilter';
import { InvoiceArticleCategoryRequest } from 'src/modules/invoice/models/invoiceArticleCategoryRequest';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'InvoiceArticleCategory';

export const getAllInvoiceArticleCategory = (filter: InvoiceArticleCategorySearchFilter) => {
  return AxiosInstance.get<PagedResult<InvoiceArticleCategory>>(`${controller}`, { params: filter });
};

export const getInvoiceArticleCategoryById = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<InvoiceArticleCategory>(endpoint);
};

export const createInvoiceArticleCategory = (data: InvoiceArticleCategoryRequest) => {
  return AxiosInstance.post<InvoiceArticleCategoryRequest>(controller, data);
};

export const updateInvoiceArticleCategory = (articleCategory: InvoiceArticleCategoryRequest) => {
  const endpoint = `${controller}`;
  return AxiosInstance.put<InvoiceArticleCategoryRequest>(endpoint, articleCategory);
};

export const deleteInvoiceArticleCategory = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete(endpoint);
};
